import styled from "styled-components";
import { COLORS } from "../../assets/constants/styles";

export const TitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  margin-bottom: 2rem;
  gap: 1rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

export const InputContainer = styled.div`
  width: 100%;
  margin-top: 1rem;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 0.75rem;
  border: 1px solid ${COLORS.lightViolet};
  border-radius: 0.75rem;
  font-family: inherit;
  font-size: 0.875rem;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: ${COLORS.violet};
  }
`;
